<template lang="pug">
  div.module-sign-in
    div.module-sign-in-content.f.fh
      div
        div.mb40
          v-img(src="/img/cert-logo.svg")
        div.f.fc.mb30
          ItemSignInWithEmail(@toggleShowSocialSignIn="showSocialSignIn = !showSocialSignIn")
        div(v-if="showSocialSignIn").mb50
          span.block.fz12.text-center.mb4 続けることで#[a(:href="privacyPolicy" target="blank").fz12 利用規約] 及び #[a(:href="serviceTerms" target="blank").fz12 プライバシーポリシー]
          span.block.fz12.text-center に同意したことになります
        div.switch-sign-in-up.f.fc
          span(@click="$router.push(($route.name == 'sign-in') ? '/sign-up' : '/sign-in')").fz12 {{($route.name == 'sign-in') ? 'アカウントをお持ちでない方' : 'アカウントをお持ちの方'}}
</template>

<style scoped lang="scss">
@import "@/scss/_variables.scss";

.module-sign-in {
  position: relative;
  .module-sign-in-content {
    margin: 0 auto;
    width: $base_width_percent;
    max-width: $base_max_width_px;
    min-height: 100vh;
    span {
      a {
        color: $active_color;
      }
    }
  }
  .switch-sign-in-up {
    span {
      color: $active_color;
    }
  }
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapActions } = createNamespacedHelpers('auth')
import ItemSignInWithEmail from '@/components/item/ItemSignInWithEmail'

export default {
  components: {
    ItemSignInWithEmail
  },
  data () {
    return {
      privacyPolicy: '/privacy_policy.pdf',
      serviceTerms: '/service_terms.pdf',
      showSocialSignIn: true
    }
  },
  computed: {
    ...mapState(['isLoggedIn'])
  },
  watch: {
    showSocialSignIn () {
      console.log('this.showSocialSignIn', this.showSocialSignIn)
    }
  }
}
</script>